<template>
  <v-footer app class="font-weight-medium">
    <v-col class="text-left" cols="12" >
      &copy; {{ new Date().getFullYear() }} <strong>Happy Games Studio LLC</strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'footer-bar'
}
</script>
